import React from 'react';

interface AlertBannerProps {}

const AlertBanner = (props: AlertBannerProps) => {
  return <></>;
};

export default AlertBanner;
